import gtm from '@/utils/gtm';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { position, color, bgColor, title, isNoFollow } = data;
    const [initTitle, setInitTitle] = useState(title);
    const { locale = 'us' } = useRouter();
    const compStyle = {
        '--editor-blog-richtext-color': color,
        '--editor-blog-richtext-bg-color': bgColor,
    };
    const refA = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const pathnameA = location.pathname;
        const initHandleA = () => {
            const elemA = refA.current;
            if (!elemA) {
                return;
            }
            elemA.addEventListener('click', (e: any) => {
                const targetA = e.target.closest('a');
                // 如果没有找到a标签，直接返回
                if (!targetA) {
                    return;
                }
                let targetB = e.target;
                if (targetB.tagName !== 'A') {
                    targetB = targetB.parentElement;
                }
                if (targetB.tagName !== 'A') {
                    targetB = targetB.parentElement;
                }

                const textA = targetB.textContent || '';
                const hrefA = targetB.getAttribute('href') || '';
                if (!hrefA || !textA) {
                    return;
                }

                if (hrefA.includes(`${locale}.ecoflow.com`)) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: textA,
                        position: `blog_${pathnameA}`,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                } else if (hrefA.includes('www.ecoflow.com')) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'select_product',
                        list_name: 'none',
                        product_name: textA,
                        button_name: textA,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                } else {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'blog_other_link',
                        button_name: textA,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                }
            });
        };
        initHandleA();
    }, []);

    useEffect(() => {
        if (!!isNoFollow) {
            const doc = new DOMParser().parseFromString(title, 'text/html');

            doc.querySelectorAll('a').forEach((a) => {
                a.setAttribute('rel', 'nofollow');
            });

            const htmlString = doc.documentElement.outerHTML;
            setInitTitle(htmlString);
        } else {
            const doc = new DOMParser().parseFromString(title, 'text/html');

            doc.querySelectorAll('a').forEach((a) => {
                a.removeAttribute('rel');
            });

            const htmlString = doc.documentElement.outerHTML;
            setInitTitle(htmlString);
        }
    }, [isNoFollow, title]);

    return (
        <GloLayout id={id} className={`editor-blog-richtext position-${position}`} style={compStyle}>
            {!!initTitle && (
                <div
                    ref={refA}
                    className="richtext-title"
                    dangerouslySetInnerHTML={{
                        __html: initTitle,
                    }}
                ></div>
            )}
        </GloLayout>
    );
}
